<template>
  <v-dialog v-model="_active" persistent :width="dialogStyle">
    <v-card style="overflow-x: hidden; height: 400px" flat class="">
      <v-card tile flat>
        <v-card-title color="primary">
          <v-container>
            <v-row class="d-flex flex-row justify-space-between">
              <span class="text-center font-weight-bold pb-0">
                Invite New Users
              </span>
              <v-btn text @click="clear">
                <v-icon xl>mdi-close</v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </v-card-title>
        <div>
          <v-form
            v-model="isFormValid"
            class="d-flex flex-column align-center pt-10"
          >
            <div style="width: 50%">
              <v-select
                solo
                :items="inviteTypes"
                item-color="secondary"
                v-model="selectedType"
              />
            </div>
            <v-row
              v-for="(invite, i) in invites"
              :key="i"
              class="pr-10 pl-10"
              style="width: 95%"
            >
              <v-text-field
                v-model="inviteEmails[i]"
                label="Email"
                filled
                required
                :error-messages="getError"
                :rules="emailRules"
                class="ma-2"
              ></v-text-field>
              <v-select
                v-if="_client.client_name === 'avis' && _getClientGroupsAreSet"
                v-model="user_locations[i]"
                label="Location"
                filled
                hide-details
                height="56px"
                class="ma-2"
                item-value="group_name"
                item-text="group_name"
                id="profile-user-state"
                :items="_client.groups"
              ></v-select>
              <v-select
                v-model="user_groups[i]"
                label="Groups Viewing"
                filled
                hide-detail
                height="56px"
                class="ma-2"
                item-value="uuid"
                item-text="group_name"
                id="profile-user-state"
                append-outer-icon="mdi-close"
                @click:append-outer="removeEmail(i)"
                :items="all_groups"
              ></v-select>
            </v-row>
          </v-form>
          <v-row class="d-flex justify-center">
            <v-btn
              color="primary"
              class="mb-2 font-weight-bold"
              :class="textStyle"
              width="150"
              @click="inviteAnother"
              >Invite Another</v-btn
            >
          </v-row>
          <v-row>
            <v-spacer />
            <v-row class="d-flex justify-center pt-10">
              <v-btn
                color="primary"
                class="ma-2 font-weight-bold"
                width="150"
                :class="textStyle"
                @click="apply"
                :disabled="!isFormValid"
                >Invite All</v-btn
              >
              <v-btn class="ma-2" text width="150" @click="clear">Cancel</v-btn>
            </v-row>
            <v-spacer />
          </v-row>
        </div>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  data: () => ({
    invites: 1,
    inviteTypes: ['user', 'admin'],
    selectedType: 'user',
    inviteEmails: [],
    user_locations: [],
    user_groups: ['all'],
    all_groups: [],
    emailRules: [v => /.+@.+/.test(v) || 'Invalid Email address'],
    isFormValid: false,
    user_location: null,
  }),
  mixins: [MobileView],
  mounted() {
    if (this._getClientGroupsAreSet) {
      this.all_groups = JSON.parse(JSON.stringify(this._client.groups));
      this.all_groups.unshift({ group_name: 'all', uuid: 'all' });
    }
  },
  methods: {
    ...mapMutations({
      _setActive: 'account/setNewInvite',
      setError: 'auth/setError',
    }),
    ...mapActions({
      _initialSignUp: 'auth/initialSignUp',
    }),
    apply() {
      this.inviteEmails.map((invite, index) => {
        const payload = {
          email: invite,
          type: this.selectedType,
          location: this.user_locations[index],
          client: this._client.client_name,
          group_id: this.user_groups[index],
        };
        this._initialSignUp(payload);
      });
    },
    clear() {
      this.invites = 1;
      this.inviteEmails = [];
      this._setActive(false);
      this.setError(null);
    },
    generatePassword() {
      const length = 10;
      const charset =
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~|}{[]:;?><,./-=';
      let retVal = '';
      for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
    inviteAnother() {
      this.invites += 1;
      this.user_groups.push('all');
    },
    removeEmail(index) {
      this.inviteEmails.splice(index, 1);
      this.invites -= 1;
    },
  },
  computed: {
    ...mapGetters({
      _active: 'account/getNewInvite',
      _client: 'account/getCurrentClient',
      getError: 'auth/getError',
      _getClientGroupsAreSet: 'account/getClientGroupsAreSet',
    }),
    dialogStyle() {
      if (this.showMobileView) {
        return '';
      }
      return '75%';
    },
  },
  watch: {
    getError() {
      if (this.getError === 'Invite Sent') {
        this._setActive(false);
      }
    },
    _getClientGroupsAreSet() {
      if (this._getClientGroupsAreSet) {
        this.all_groups = JSON.parse(JSON.stringify(this._client.groups));
        this.all_groups.unshift({ group_name: 'all', uuid: 'all' });
      }
    },
  },
};
</script>

<style></style>
